export default "__VITE_ASSET__Cl3Iy392__"